import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getLoginUrl, getNewDomainUrl } from '@/selectors/configSelectors';
import { useRouteParams } from '@/context/routeParamsContext';
import { getBasePathFromLocation, isNewUrl } from '@/helpers/utils';
import { getIsCheckingAuth, getIsNotLoggedIn } from '@/selectors/authSelectors';

export const useIsRedirectingCenturionToLogin = () => {
  const { product } = useRouteParams();
  const isNotLoggedIn = useSelector(getIsNotLoggedIn);
  const isCheckingAuth = useSelector(getIsCheckingAuth);
  const isCenturionProduct = product === 'the-centurion-card';
  return (isCheckingAuth || isNotLoggedIn) && isCenturionProduct;
};

export const useCenturionForcedLoginRedirection = ({ params, locale }) => {
  const isNotLoggedIn = useSelector(getIsNotLoggedIn);
  const loginOrigin = useSelector(getLoginUrl);
  const newDomain = useSelector(getNewDomainUrl);

  useEffect(() => {
    if (isNotLoggedIn && params?.product === 'the-centurion-card') {
      const basePath = getBasePathFromLocation(
        locale,
        window.location.pathname
      );
      let origin = `https://${window.location.hostname}`; // includes the protocol to match with override value from "if" statement below.
      let returnUrlQueryParams = `?locale=${locale.toLocaleLowerCase()}`;
      if (isNewUrl(window.location.pathname)) {
        origin = newDomain; // includes the protocol
        returnUrlQueryParams = '';
      }
      const returnUrl = `${origin}${basePath}/${params?.product}${returnUrlQueryParams}`;
      const fullUrl = `${loginOrigin}/${locale}/account/login?DestPage=${encodeURIComponent(returnUrl)}`;
      window.location.assign(fullUrl);
    }
  }, [isNotLoggedIn, loginOrigin, locale, params?.product, newDomain]);
};
